// src/components/AddCompanyForm/ContactCard.jsx
import React from "react";
import {
  Card, CardHeader, CardContent, Grid, TextField, InputAdornment,
} from "@mui/material";
import EmailRoundedIcon from "@mui/icons-material/EmailRounded";
import PhoneRoundedIcon from "@mui/icons-material/PhoneRounded";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import AccessTimeRoundedIcon from "@mui/icons-material/AccessTimeRounded";

export default function ContactCard({ form, setForm }) {
  const set = (patch) => setForm((p) => ({ ...p, ...patch }));
  return (
    <Card variant="outlined">
      <CardHeader title="Contato & Atendimento" subheader="E-mails, telefones e horário" />
      <CardContent sx={{ pt: 0 }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label="E-mail"
              value={form.email}
              onChange={(e) => set({ email: e.target.value })}
              fullWidth
              InputProps={{ startAdornment: <InputAdornment position="start"><EmailRoundedIcon fontSize="small" /></InputAdornment> }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label="Telefone"
              value={form.telefone}
              onChange={(e) => set({ telefone: e.target.value })}
              fullWidth
              InputProps={{ startAdornment: <InputAdornment position="start"><PhoneRoundedIcon fontSize="small" /></InputAdornment> }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label="Telefone adicional"
              value={form.telefone_adicional}
              onChange={(e) => set({ telefone_adicional: e.target.value })}
              fullWidth
              InputProps={{ startAdornment: <InputAdornment position="start"><PhoneRoundedIcon fontSize="small" /></InputAdornment> }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label="E-mail de suporte"
              value={form.support_email}
              onChange={(e) => set({ support_email: e.target.value })}
              fullWidth
              InputProps={{ startAdornment: <InputAdornment position="start"><EmailRoundedIcon fontSize="small" /></InputAdornment> }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label="WhatsApp de suporte"
              value={form.support_whatsapp}
              onChange={(e) => set({ support_whatsapp: e.target.value })}
              fullWidth
              helperText="Apenas números, com DDD. Ex.: 11987654321"
              InputProps={{ startAdornment: <InputAdornment position="start"><WhatsAppIcon fontSize="small" /></InputAdornment> }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Horário de atendimento"
              value={form.atendimento_horario}
              onChange={(e) => set({ atendimento_horario: e.target.value })}
              fullWidth
              placeholder="Seg–Sex: 8h–18h | Sáb: 8h–12h"
              InputProps={{ startAdornment: <InputAdornment position="start"><AccessTimeRoundedIcon fontSize="small" /></InputAdornment> }}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
